"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListUsersQuerySchema = exports.GetUserMetadataBodySchema = exports.UpdateUserMetadataBodySchema = exports.UpdateUserBodySchema = exports.CreateUserBodySchema = exports.GetMeResponseSchema = exports.ListUsersResponseSchema = exports.UpdateUserMetadataResponseSchema = exports.GetUserMetadataResponseSchema = exports.UpdateUserResponseSchema = exports.CreateUserResponseSchema = exports.GetUserResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
/**
 * Response
 */
exports.GetUserResponseSchema = common_1.UserSchema;
exports.CreateUserResponseSchema = common_1.UserSchema;
exports.UpdateUserResponseSchema = common_1.UserSchema;
exports.GetUserMetadataResponseSchema = common_1.UserMetadataSchema;
exports.UpdateUserMetadataResponseSchema = common_1.UserMetadataSchema;
exports.ListUsersResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.GetUserResponseSchema);
exports.GetMeResponseSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    name: core_1.NameSchema,
    email: typebox_1.Type.Optional(core_1.EmailSchema),
    role: ruby_1.UserRoleSchema,
    metadata: common_1.UserMetadataSchema,
});
/**
 * Body
 */
exports.CreateUserBodySchema = (0, core_1.StrictObject)({
    subject: ruby_1.SubjectSchema,
    name: core_1.NameSchema,
    email: typebox_1.Type.Optional(core_1.EmailSchema),
    role: ruby_1.UserRoleSchema,
    status: ruby_1.UserStatusSchema,
});
exports.UpdateUserBodySchema = (0, core_1.StrictObject)({
    subject: typebox_1.Type.Optional(ruby_1.SubjectSchema),
    name: typebox_1.Type.Optional(core_1.NameSchema),
    email: typebox_1.Type.Optional(core_1.EmailSchema),
    role: typebox_1.Type.Optional(ruby_1.UserRoleSchema),
    status: typebox_1.Type.Optional(ruby_1.UserStatusSchema),
});
exports.UpdateUserMetadataBodySchema = common_1.UserMetadataSchema;
exports.GetUserMetadataBodySchema = common_1.UserMetadataSchema;
/**
 * Parameters
 */
exports.ListUsersQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
